import React, { useMemo, useState } from 'react';
import { Redirect, Route, Switch, useLocation } from 'react-router';
import {
  adminEntities,
  ADMIN_PAGES_VIEW_ACCORDING_TO_ROLE,
  ADMIN_ROLE,
  ORG_ADMIN_ROLE,
  PROCESSOR_ROLE,
  ROLE_ORG_STAFF,
  SALES_PERSON_ROLE,
} from '../../helpers/constants';
import EntityCRUD from '../EntityCrud/EntityCrud';
import NotFound from '../NotFound';
import AppChoices from './AppChoices';
import UsersFromCompany from './UsersFromCompany';
import useAppChoices from '../../hooks/useAppChoices';
import { isAdmin, isStaff } from '../../helpers/global';
import TeamManagement from './TeamManagement/TeamManagement';
import BackOffice from '../BackOffice';
import FinancialIntelligence from '../FinancialIntelligence';
import StatementPage from '../statement/StatementPage';

const Index = ({ currentUserInfo }) => {
  const [role] = useState(localStorage.getItem('user-role'));
  const [usersFromOrganization, setUsersFromOrganization] = useState(null);
  const users = useAppChoices('users') || [];
  const requiredUsers = users.filter(user => isStaff(user.role) && !user.organization);

  const { pathname } = useLocation();

  const onUsersFromOrganizationChange = value => {
    setUsersFromOrganization(value);
  };

  if (role !== ADMIN_ROLE && !ADMIN_PAGES_VIEW_ACCORDING_TO_ROLE[role]?.routes?.includes(pathname)) {
    return <NotFound />;
  }

  const isAllowedEmail = currentUserInfo?.hasFinancialIntelligenceAccess;

  return (
    <>
      <UsersFromCompany
        usersFromOrganization={usersFromOrganization}
        onUsersFromOrganizationChange={onUsersFromOrganizationChange}
      />

      <Switch>
        {adminEntities(
          usersFromOrganization || role === ORG_ADMIN_ROLE
            ? [ORG_ADMIN_ROLE, ROLE_ORG_STAFF]
            : [PROCESSOR_ROLE, ADMIN_ROLE, SALES_PERSON_ROLE],
          requiredUsers
        ).map(e => (
          <Route key={`admin-${e.route}`} path={`/admin${e.route}`} exact>
            <EntityCRUD
              entityAppChoiceKey={e.appChoiceKey}
              entityName={e.name}
              endpoint={e.endpoint}
              entityTableHeaders={e.tableHeaders}
              entityTableSearchKeys={e.searchKeys}
              addFormRows={e.addRows}
              updateFormRows={e.updateRows}
              onUsersFromOrganizationChange={onUsersFromOrganizationChange}
              updateEndpoint={e.updateEndpoint}
            />
          </Route>
        ))}

        <Route path="/admin/app-choices">
          <AppChoices />
        </Route>

        <Route path="/admin/back-office">
          <BackOffice />
        </Route>

        {
          isAllowedEmail && isAdmin(role) && (
            <Route path="/admin/financial-intelligence">
              <FinancialIntelligence currentUserInfo={currentUserInfo} />
            </Route>
          )
        }

        <Route path="/admin/team-management" exact>
          <TeamManagement />
        </Route>

        <Route path="/admin/statement">
          <StatementPage />
        </Route>

        <Route path="*">
          <NotFound />
        </Route>
      </Switch>
    </>
  );
};

export default Index;
